import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useContext} from 'react'
import {NullAsDefault, renderIf, renderMail, renderPhone,} from 'views/Shared'
import {IdentifierTypes} from "../../../AppLocals/appFieldTypes";
import {Avatar, message} from "antd";
import {FaAddressCard, FaUserGraduate} from "react-icons/fa6";
import {renderIfElse} from "../../../Shared";
import ImageLoader from "../../../../components/ImageLoader";
import getTitle from "../../../../helpers/getTitle";
import copyToClipboard from "copy-to-clipboard";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {
    DatePlaceItem,
    DoubleValueItem
} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {IoCopyOutline} from "react-icons/io5";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {StudentActionTypes} from "../../../AppLocals/Course";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import getAliasName from "../../../../helpers/getAliasName";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {GoDotFill} from "react-icons/go";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const renderStudent = ({renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        avatar,
        edit,
        user,
        fullname,
        gender,
        date_of_birth,
        place_of_birth,
        contact_phone,
        contact_email,
        student_idcode,
        identifier_code,
        identifier_type,
        medal_awards = [],
        religious_order,
        religious_order_name,
        patron_saint_name,
    } = item ?? {}

    const {isSm} = useContext(LayoutContext)

    return (
        <Translate key={index}>
            {(t) => (
                <div
                    className="p-3 flex flex-col border border-color-50 shadow-md rounded-lg hover:scale-xs custom-item-render relative">
                    <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                        {renderIfElse(
                            avatar,
                            <Avatar
                                size={35}
                                className="flex flex-center background-200"
                                src={avatar}
                                icon={<FaUserGraduate size={15} className="text-color-500"/>}
                            />,
                            <Avatar size={35} src={user?.avatar}
                                    icon={<FaUserGraduate size={15} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                            />
                        )}
                        <div className="flex flex-col">
                            <h2
                                onClick={() => {
                                    handleAction(StudentActionTypes.STUDENT_DETAIL, item)
                                }}
                                className="flex items-baseline gap-1 font-bold text-lg text-color-000 hover:text-primary cursor-pointer leading-snug">
                                <span className="font-medium text-sm text-color-100 italic">
                                    {getAliasName(item, 'patron_saint')}
                                </span>
                                {fullname}
                            </h2>
                            <div className="flex items-center gap-6">
                                {
                                    student_idcode && (
                                        <div className="text-2xs md:text-xs italic">
                                        <span className="text-color-400 whitespace-no-wrap">
                                            {isSm ? '#' : `${t('student code')} : `}
                                        </span>
                                            <span
                                                onClick={() => {
                                                    copyToClipboard(student_idcode)
                                                    message.info(t('copied'))
                                                }}
                                                className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                                            {student_idcode}
                                                <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                                        </div>
                                    )}
                                {
                                    (edit === true && identifier_code) && (
                                        <div className="flex items-center text-2xs md:text-xs gap-1">
                                            {isSm ?
                                                <FaAddressCard size={12} className="mr-1"/> :
                                                <span className="mr-1 text-color-400 italic whitespace-no-wrap">
                                                {`${t(_.find(IdentifierTypes, {value: identifier_type})?.label)} : `}
                                            </span>
                                            }
                                            <span
                                                onClick={() => {
                                                    copyToClipboard(identifier_code)
                                                    message.info(t('copied'))
                                                }}
                                                className="font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                            {identifier_code}
                                                <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                    <div className="ml-3 flex flex-col flex-1 gap-1">
                        <div className="flex flex-col md:flex-row gap-x-6 gap-y-1">
                            {_.some([date_of_birth, place_of_birth]) && (
                                <DatePlaceItem
                                    showIcon={true}
                                    label="date of birth"
                                    date={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                    place={place_of_birth}
                                    className="text-xs italic"
                                />
                            )}
                            {
                                gender !== 0 && (
                                    <ItemInformation
                                        showIcon={true}
                                        label="gender"
                                        value={t(getLabelOfGender(gender))}
                                        className="text-xs italic"
                                    />
                                )}
                        </div>
                        {
                            _.some([contact_phone, contact_email]) && (
                                <DoubleValueItem
                                    showIcon={true}
                                    labelFirst="contact"
                                    valueFirst={renderPhone(contact_phone)}
                                    labelSecond={contact_email ? ' - ' : ''}
                                    valueSecond={renderMail(contact_email)}
                                    className="text-xs italic"
                                />
                            )}
                        {
                            religious_order_name && (
                                <ItemInformation
                                    showIcon={true}
                                    label="belong to religious order"
                                    value={
                                        <Link to={getLinkToDetail(religious_order)} className="no-underline">
                                            {religious_order_name}
                                        </Link>
                                    }
                                    className="text-xs italic"
                                />
                            )}
                        {
                            medal_awards?.length > 0 && (
                                <div className="flex items-center gap-3">
                                    <GoDotFill size={10} className="text-color-500"/>
                                    <span className="text-xs text-color-500 italic">
                                    {`${t('certification awarded')} : `}
                                </span>
                                    {medal_awards.map((e, i) => (
                                        <div
                                            key={i}
                                            className="flex items-center gap-3">
                                        <span
                                            key={i}
                                            className="font-bold text-xs text-primary italic">
                                                {getTitle(e.medal)}
                                        </span>
                                            {renderIf(
                                                e?.medal?.avatar,
                                                <ImageLoader
                                                    src={e?.medal?.avatar}
                                                    style={{width: 30, height: 25}}
                                                />
                                            )}
                                            {i < medal_awards.length - 1 && ', '}
                                        </div>
                                    ))}
                                </div>
                            )}
                    </div>
                    <div className="absolute right-5 top-5 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}
